import * as React from 'react';
import { Alert, Button, Modal, Typography } from 'antd';

type Props = {
    rawKey: string | null;
    onClose: () => void;
};

const { Paragraph } = Typography;

const ApiKeySecretModal: React.FC<Props> = ({ rawKey, onClose }) => (
    <Modal
        className="alpha-portal-dialog"
        title="Copy the API key"
        visible={rawKey !== null}
        onCancel={onClose}
        maskClosable={false}
        destroyOnClose
        centered
        footer={[
            <Button key="done" type="primary" size="large" onClick={onClose}>
                Done
            </Button>
        ]}
    >
        <Alert
            type="warning"
            showIcon
            message="This key is shown only once. Copy and store it securely now."
            style={{ marginBottom: 16 }}
        />
        <Paragraph copyable={{ text: rawKey ?? '' }} style={{ overflowWrap: 'anywhere' }}>
            {rawKey}
        </Paragraph>
    </Modal>
);

export default ApiKeySecretModal;
